import { render, staticRenderFns } from "./Type.vue?vue&type=template&id=77b2eed5&scoped=true&"
import script from "./Type.vue?vue&type=script&lang=js&"
export * from "./Type.vue?vue&type=script&lang=js&"
import style0 from "./Type.vue?vue&type=style&index=0&id=77b2eed5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b2eed5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77b2eed5')) {
      api.createRecord('77b2eed5', component.options)
    } else {
      api.reload('77b2eed5', component.options)
    }
    module.hot.accept("./Type.vue?vue&type=template&id=77b2eed5&scoped=true&", function () {
      api.rerender('77b2eed5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/uniform/components/Type.vue"
export default component.exports